<template>
  <BaseCard class="flex flex-col">
    <BaseCardHeader>
      <h3 class="text-base truncate">
        {{ audience.name }}
      </h3>
    </BaseCardHeader>
    <div class="aspect-w-16 aspect-h-9 bg-gray-100">
      <img
        v-if="audience.cover && audience.cover.url"
        :src="audience.cover.url"
        :alt="audience.cover.name"
        class="w-full h-full object-cover"
      />
    </div>
    <BaseCardBody class="flex-1">
      <template v-if="audience.model">
        <AudienceCardFacebookDetails v-if="isFacebookAudience" :audience="audience" class="mt-8" />
        <AudienceCardSavedQueryDetails v-else-if="isSavedQuery" :audience="audience" class="mt-8" />
        <AudienceCardGaUserListDetails v-else-if="isGaUserList" :audience="audience" class="mt-8" />
      </template>
    </BaseCardBody>
    <BaseCardFooter class="flex-none">
      <div class="flex space-x-2 items-center justify-end">
        <AudienceEditAction :audience="audience" :on-updated="handleOnUpdated" />
        <AudienceSyncAction v-if="!isGaUserList" :audience="audience" :on-synced="handleOnSynced" />
        <AudienceDeleteAction :audience="audience" :on-deleted="handleOnDeleted" />
      </div>
    </BaseCardFooter>
  </BaseCard>
</template>

<script>
import AudienceCardFacebookDetails from './AudienceCardFacebookDetails.vue';
import AudienceCardSavedQueryDetails from './AudienceCardSavedQueryDetails.vue';
import AudienceCardGaUserListDetails from './AudienceCardGaUserListDetails.vue';
import AudienceEditAction from './AudienceEditAction.vue';
import AudienceSyncAction from './AudienceSyncAction.vue';
import AudienceDeleteAction from './AudienceDeleteAction.vue';

export default {
  components: {
    AudienceCardFacebookDetails,
    AudienceCardSavedQueryDetails,
    AudienceCardGaUserListDetails,
    AudienceEditAction,
    AudienceSyncAction,
    AudienceDeleteAction,
  },
  props: {
    audience: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFacebookAudience() {
      return (
        ['facebook_saved_audiences', 'facebook_custom_audiences'].indexOf(
          this.audience.model_type
        ) >= 0
      );
    },
    isSavedQuery() {
      return this.audience.model_type === 'saved_queries';
    },
    isGaUserList() {
      return this.audience.model_type === 'ga_user_list';
    },
  },
  methods: {
    handleOnUpdated(updatedAudience) {
      this.$emit('audience-updated', updatedAudience);
    },
    handleOnSynced(syncedAudience) {
      this.$emit('audience-synced', syncedAudience);
    },
    handleOnDeleted() {
      this.$emit('audience-deleted');
    },
  },
};
</script>
